import {LeftOutlined} from '@ant-design/icons';
import {Button} from '@ds/components';
import {useNavigate} from 'react-router-dom';

type StockLineProps = {
  title: string;
  inStock: number;
  outOfStock: number;
  type: 'atp' | 'penetration';
  vendorId: string | number;
};

const StockLine: React.FC<StockLineProps> = ({title, inStock, outOfStock, type, vendorId}) => {
  const navigate = useNavigate();
  const total = inStock + outOfStock;
  const availablePercentage = total > 0 ? (inStock / total) * 100 : 0;

  const showDetails = () => {
    navigate(type === 'atp' ? '/chortke/show/BSS' : '/chortke/show/BSR', {
      state: {
        vendorId,
        type: type === 'atp' ? 'assortment vendor' : 'assortment region'
      }
    });
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-body-sm-emphasis text-neutral-fg">{title}</h3>
        <Button
          variant="link"
          color="secondary"
          size="sm"
          className="shrink-0 px-0"
          endIcon={<LeftOutlined aria-hidden />}
          onClick={showDetails}
        >
          جزئیات
        </Button>
      </div>
      <p className="text-body-sm-emphasis text-gray-08">
        {type === 'penetration' ? 'تعداد' : 'ناموجود'}: {outOfStock} کالا
      </p>
      {type === 'atp' && (
        <>
          <div className="flex h-4 overflow-hidden rounded-sm bg-destructive-surface">
            <div
              className="bg-success"
              style={{width: `${availablePercentage}%`}}
              aria-label={`${inStock} کالای موجود`}
            />
          </div>
          <div className="flex gap-5 text-body-sm text-gray-07">
            <span className="flex items-center gap-2">
              <span className="h-2.5 w-2.5 rounded-full bg-success" aria-hidden />
              موجود
            </span>
            <span className="flex items-center gap-2">
              <span className="h-2.5 w-2.5 rounded-full bg-destructive" aria-hidden />
              ناموجود
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default StockLine;
